import { useEffect, useState } from 'react';

const cardStyle = {
  input: {
    fontSize: '16px',
    fontFamily: 'helvetica neue, sans-serif',
    color: '#1f2937',
  },
  'input::placeholder': {
    color: '#9ca3af',
  },
  '.input-container': {
    borderColor: '#d1d5db',
    borderRadius: '6px',
  },
  '.input-container.is-focus': {
    borderColor: '#6366f1',
  },
  '.input-container.is-error': {
    borderColor: '#ef4444',
  },
  '.message-text': {
    color: '#6b7280',
  },
  '.message-text.is-error': {
    color: '#ef4444',
  },
  '.message-icon': {
    color: '#6b7280',
  },
  '.message-icon.is-error': {
    color: '#ef4444',
  },
};

export function SquarePaymentComponent(props) {
  const { card, setCard } = props;
  const [loading, setLoading] = useState(true);

  useEffect(async () => {
    async function setPaymentCard() {
      if (!card) {
        const applicationId =
          process.env.NODE_ENV === 'development'
            ? 'sandbox-sq0idb-iEPDS43sHJwMG3Jg9ZSBTA'
            : process.env.REACT_APP_APPLICATION_ID;
        /*global Square*/
        const payments = Square.payments(
          applicationId,
          process.env.REACT_APP_SQUARE_LOCATION_ID,
        );
        const cardRes = await payments.card({ style: cardStyle });
        setCard(cardRes);
      }
    }
    await setPaymentCard();
    if (card && loading) {
      await card?.attach('#square-card-target');
      setLoading(false);
    }
  }, [card]);

  return <></>;
}
